import { render, staticRenderFns } from "./DialogViewClaimRequests.vue?vue&type=template&id=031a7b64&scoped=true&"
import script from "./DialogViewClaimRequests.vue?vue&type=script&lang=js&"
export * from "./DialogViewClaimRequests.vue?vue&type=script&lang=js&"
import style0 from "./DialogViewClaimRequests.vue?vue&type=style&index=0&id=031a7b64&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031a7b64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VContainer,VDataTable,VDialog,VIcon,VTooltip})
